import React from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Box,
} from "@mui/material";
import { Car, Bus, Truck } from "lucide-react";
import { useTranslation } from "react-i18next";


const OPTIONS = [
  { type: null, key: "all", icon: null },
  { type: "wait", key: "wait", icon: <Bus size={18} /> },
  { type: "express", key: "express", icon: <Car size={18} /> },
  { type: "van", key: "van", icon: <Truck size={18} /> },
];

export function TransportModal({ open, onClose, value, onChange }) {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{t("drive.transportModal.title")}</DialogTitle>
      <DialogContent>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1, pt: 0.5 }}>
          {OPTIONS.map(({ type, key, icon }) => (
            <Button
              key={String(type)}
              variant={value === type ? "contained" : "outlined"}
              disableElevation
              startIcon={icon}
              onClick={() => { onChange(type); onClose(); }}
              sx={{
                textTransform: "none",
                fontWeight: 600,
                justifyContent: "flex-start",
                py: 1.25,
                px: 2,
              }}
            >
              {t(`drive.transportModal.options.${key}`)}
            </Button>
          ))}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} sx={{ textTransform: "none" }}>
          {t("common.cancel")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
